import { render } from "./Uploads.vue?vue&type=template&id=567799b3"
import script from "./Uploads.vue?vue&type=script&lang=js"
export * from "./Uploads.vue?vue&type=script&lang=js"

import "./Uploads.vue?vue&type=style&index=0&id=567799b3&lang=css"

import exportComponent from "/home/debian/plan.docks40.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__